import {
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
} from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { LexTableCellDirective } from './lex-table-cell.directive';

export interface LexTableColumn {
  id: string;
  label: string;
}

export interface LexTableAction {
  icon: string;
  action: ($event, item) => void;
  disabled?: (item) => boolean;
  tooltip?: (item) => string;
}

export interface ClickEvent {
  item: any;
  event: any;
}

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-table',
  templateUrl: './lex-table.component.html',
  styleUrls: ['./lex-table.component.scss'],
  standalone: false,
})
export class LexTableComponent implements OnInit, OnChanges {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() columns: LexTableColumn[];
  @Input() rows: any[];
  @Input() selectable = true;
  @Input() multiselect: boolean;
  @Input() actions: LexTableAction[];
  @Input() tableClass: string;
  @Input() dense: boolean;
  @Input() emptyViewLabel: string;
  @Input() itemSize = 40;
  /* eslint-disable @typescript-eslint/member-ordering */
  @Input() rowClass: (item) => string | any[] | { [key: string]: any } = () => '';

  @Output() rowClicked = new EventEmitter<ClickEvent>();

  @ContentChildren(LexTableCellDirective, { descendants: true })
  rowCells: QueryList<LexTableCellDirective>;

  selectedItems: any[] = [];

  disableRipple: boolean;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes) {
    if (changes.selectable) {
      this.disableRipple = !this.selectable ? true : this.disableRipple;
    }
  }

  isItemSelected(item) {
    return this.selectedItems.includes(item);
  }

  onRowClicked(item, event) {
    if (this.selectable) {
      this.toggleItem(item);
      this.rowClicked.emit({ item, event });
    }
  }

  private toggleItem(item) {
    const idx = this.selectedItems.indexOf(item);
    if (idx > -1) {
      this.selectedItems.splice(idx, 1);
    } else {
      if (this.multiselect) {
        this.selectedItems.push(item);
      } else {
        this.selectedItems[0] = item;
      }
    }
  }

  onActionClicked($event, btn, item) {
    $event.detail.nativeEvent.stopImmediatePropagation();
    btn.action($event, item);
  }
}
